import axios from '@/config/axios'

const authBase = '/v1/api/mg/auth'
export const login = (form) => axios.post(`${authBase}/session`, form)

export const allProperty = () => axios.get(`${authBase}/property`)


export const updateSessionProperty = (data) => axios.patch(`${authBase}/session`, data)

